import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { AwayPeriodOptions } from "../../utils/Utils";


const AwayPeriodDropdown = ({ value, isMulti = false, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    setList(AwayPeriodOptions);
    return () => {
      setList();
    };
  }, []);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? null}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};

export default AwayPeriodDropdown;